import * as e from "react";
var t = e.createContext(!1), r = () => e.useContext(t);
t.Provider;
export {
  r as useIsRestoring
};
//# sourceMappingURL=contact-channels72.js.map
